/** Links externos da integração Saipos (Atendabot). */

export const SAIPOS_ACCOUNT_URL = 'https://conta.saipos.com/';

export const SAIPOS_TUTORIAL_URL =
  'https://www.youtube-nocookie.com/embed/6oXGUJdzpFs';
